(function () {
  var SECTION_SELECTOR = '.oddit-section-video-cta';
  var MEDIA_SELECTOR = '.oddit-section-video-cta__media';
  var VIDEO_SELECTOR = '.oddit-section-video-cta__video';
  var PLAY_BTN_SELECTOR = '.oddit-section-video-cta__play-btn';
  var CTA_SELECTOR = '.oddit-section-video-cta__cta';

  function initSection(section) {
    var media = section.querySelector(MEDIA_SELECTOR);
    if (!media) return;

    var video = media.querySelector(VIDEO_SELECTOR);
    var playBtn = media.querySelector(PLAY_BTN_SELECTOR);
    var ctaBtn = section.querySelector(CTA_SELECTOR);

    if (video && playBtn && playBtn.tagName !== 'A') {
      playBtn.addEventListener('click', function () {
        media.classList.add('is-playing');
        video.controls = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });

      video.addEventListener('ended', function () {
        media.classList.remove('is-playing');
        video.controls = false;
        video.currentTime = 0;
      });
    }

    if (ctaBtn && playBtn) {
      ctaBtn.addEventListener('click', function () {
        playBtn.click();
      });
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
